export class EscalatedNotePostCommand{
    verificationId: string;
    escalationReason: string;

    constructor(id:string, reason:string){
        this.verificationId = id;
        this.escalationReason = reason;
    }
}
